import type { KpiVM } from "../mappers";
import { C, card, tabular, toneColor } from "../theme";

export const KpiTile = ({ kpi }: { kpi: KpiVM }) => (
  <div
    style={{
      ...card,
      padding: "16px 18px",
      display: "flex",
      flexDirection: "column",
      gap: 6,
    }}
  >
    <span style={{ fontSize: 12, color: C.muted }}>{kpi.label}</span>
    <span
      style={{
        ...tabular,
        fontSize: 22,
        fontWeight: 700,
        color: kpi.tone === "neutral" ? C.white : toneColor(kpi.tone),
      }}
    >
      {kpi.value}
    </span>
    <span style={{ fontSize: 11, color: C.muted }}>{kpi.sub}</span>
  </div>
);
